import { render, staticRenderFns } from "./OrderableUpdateProductDialog.vue?vue&type=template&id=47a27500&"
import script from "./OrderableUpdateProductDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderableUpdateProductDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports